export const PAGE_COLORS = {
  dashboard: {
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-900',
    borderColor: 'border-blue-500'
  },
  jobs: {
    bgColor: 'bg-green-50',
    textColor: 'text-green-900',
    borderColor: 'border-green-500'
  },
  orders: {
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-900',
    borderColor: 'border-purple-500'
  },
  production: {
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-900',
    borderColor: 'border-orange-500'
  },
  delivery: {
    bgColor: 'bg-teal-50',
    textColor: 'text-teal-900',
    borderColor: 'border-teal-500'
  },
  calendar: {
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-900',
    borderColor: 'border-pink-500'
  },
  profile: {
    bgColor: 'bg-indigo-50',
    textColor: 'text-indigo-900',
    borderColor: 'border-indigo-500'
  },
  settings: {
    bgColor: 'bg-gray-50',
    textColor: 'text-gray-900',
    borderColor: 'border-gray-500'
  },
  productionLine: {
    bgColor: 'bg-indigo-50',
    textColor: 'text-indigo-900',
    borderColor: 'border-indigo-500'
  },
  pallet: {
    bgColor: 'bg-amber-50',
    textColor: 'text-amber-900',
    borderColor: 'border-amber-500'
  }
} as const;

export type PageType = keyof typeof PAGE_COLORS;
